const Drawer = {
    variants: {
        mapDrawer: {
            parts: ['dialog, dialogContainer'],
            dialog: {
                pointerEvents: 'auto',
            },
            dialogContainer: {
                pointerEvents: 'none',
            },
        },
    },
    sizes: {
        map_md: {
            dialog: {
                maxW: '550px',
            },
        },
    },
};

export default Drawer;
